import React from 'react';

import UnauthorizedNavigator from './unauthorizedNavigator';

const AppNavigator = () => {
    return (<UnauthorizedNavigator />);
}

export default AppNavigator;
